import Transpos from "./TransposApp";

// Руководство:

// в tasks - идет добавление заданий, делящихся на раунды (ссылки создаются автоматически, с названием заданным id)

// id — идентификатор уровня. Используется в адресной строке.

// rounds — массив раундов.
// Каждый раунд содержит:
// • textBySyllables — массив строк загадки. Слова разделяются на слоги символом "|".
// • correctAnswer — правильный ответ на загадку.

// Регистр букв в textBySyllables и correctAnswer не имеет значения.
// Имеется тест для проверки валидности всего, что задается в tasks

const tasks = [
  //*начало задания
  {
    id: "1", // название задания (будет как первый аргумент после названия игры в строке поиска )

    // массив раундов
    rounds: [
      
      // начало 1 раунда
      {
        textBySyllables: [
          "Ле|жит до|щеч|ка у эк|ра|на",
          "Бук|вам кноп|кам о|на ма|ма!",
          "Зна|ет рус|ский ал|фа|вит",
          "И ан|глий|ским у|ди|вит -",
          "О|чень ум|на|я на|ту|ра!",
          "Э|то что?",
        ], // массив строк загадки
        correctAnswer: "Клавиатура", //правильный ответ на загадку
      },
      // конец 1 раунда

      {
        textBySyllables: [
          "Ес|ли с вер|ны|ми друзь|я|ми",
          "Ты от|пра|вил|ся в по|ход,",
          "Про не|го ска|жу я точ|но:",
          "Он те|бя не под|ве|дёт.",
          "Вер|ный путь до|мой у|ка|жет,",
          "Стрел|кой се|вер нам по|ка|жет.",
        ],
        correctAnswer: "Компас",
      },
    ],
  },
  //*конец задания

  {
    id: "2",
    rounds: [
      {
        textBySyllables: ["С|т|р|е|л|к|о|й с|е|в|е|р н|а|м п|о|к|а|ж|е|т."],
        correctAnswer: "1",
      },
    ],
  },
];



// Дополнительные параметры в адресной строке:
// Здесь можно редактировать запись в строке поиска, например, названия игры (изначально Transpos)

// Формы записи аргументов (изначальных):
// /r    — случайный порядок раундов.
// /help — отображает кнопку «Разбить на слоги».
//
// Примеры:
// /Transpos/1
// /Transpos/1/r
// /Transpos/1/help
// /Transpos/1/r/help

// (число 1 в примере - это аргумент id, который задается в tasks)'

// Порядок /r и /help значения не имеет.

// все ссылки автоматически раскрываются (передаются) в index.tsx

const transposRoutes = tasks.flatMap((task) => [
  {
    path: `/Transpos/${task.id}`,
    element: <Transpos random={false} rounds={task.rounds} help={false} />,
  },
  {
    path: `/Transpos/${task.id}/help`,
    element: <Transpos random={false} rounds={task.rounds} help={true} />,
  },
  {
    path: `/Transpos/${task.id}/r`,
    element: <Transpos random={true} rounds={task.rounds} help={false} />,
  },
  {
    path: `/Transpos/${task.id}/r/help`,
    element: <Transpos random={true} rounds={task.rounds} help={true} />,
  },
  {
    path: `/Transpos/${task.id}/help/r`,
    element: <Transpos random={true} rounds={task.rounds} help={true} />,
  },
]);
export default transposRoutes;
